import React from "react";
import Icon from "./Icon";
import b from "./images/back-black.png";
import w from "./images/back-white.png";

export default function BackIcon({
    enableDarkTheme,
    onClick,
}: {
    enableDarkTheme: boolean;
    onClick: () => void;
}) {
    return (
        <Icon
            w={w}
            b={b}
            width={34}
            height={34}
            enableDarkTheme={enableDarkTheme}
            onClick={onClick}
        />
    );
}
